module.exports = __webpack_public_path__ + "static/media/zoomin.e984a593.svg";